export default "__VITE_ASSET__DQ85D2Lx__"